function setWidth() {
  const value = window.innerWidth - document.documentElement.clientWidth
  document.documentElement.style.setProperty('--scrollbar-width', value + 'px')
}

function setVh() {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

let timeout

window.addEventListener('resize', function () {
  clearTimeout(timeout)
  timeout = setTimeout(() => {
    setWidth()
    setVh()
  }, 500)
})

setWidth()
setVh()
